module.exports = __webpack_public_path__ + "assets/images/coin-10-on.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/coin-10-on.png
// module id = 1502
// module chunks = 1